module.exports = __webpack_public_path__ + "static/media/tl.64517b98.svg";